import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Row, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import {
  UpdateViewDetailReportService,
  fetchViewDetailReport,
  getDownloadReport,
  getReasonAuditListing,
  intiateExceptionFlow,
  nsaApproveKYSReport,
  nsaApproveReport,
  nsaRequestReviewReport,
  reAuditFlow,
} from "../../../Action";
import { Controller, useForm } from "react-hook-form";
import Toaster from "../../../../../common/Toaster";
import LoaderCustom from "../../../../../common/LoaderCustom";
import PopupMsgWrapper from "../../../../../common/PopupMsgWrapper";
import { notify, userDetails } from "../../../../../../helper";
import {
  DatePickerHookForm,
  SearchableSelectHookForm,
  TextAreaHookForm,
} from "../../../../../layout/HookFormInputs";
import ImageGallery from "./Imagegallery";
import { getVendorListFormDetailById } from "../../../../VendorNeedList/Action";
import ExceptionFlowSummary from "./ExceptionFlowSummary";
import axiosHelper from "../../../../../../axiosHelper";
import { API, APIUSEROLD } from "../../../../../../config/constants";
const ViewDetailedReport = ({ viewDataFromSupplier, setAuditStatusTab, setAuditStatusFlagCheck, setViewDataFromReport, setDeleteFlagCheck }) => {
  const popUpFormRef = useRef(null);
  const {
    formState: { errors },
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const {
    control: popFormControl,
    formState: { errors: popFormErrors },
    register: popFormRegister,

    getValues: popFormGetValues,
    setValue: popFormSetvalue,
    setError: popFormSetError,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const {
    control: popUpReauditControl,
    formState: { errors: popUpReauditErrors },
    register: popUpReauditRegister,
    getValues: popUpReauditGetValues,
    setError: popUpReauditSetError,
  } = useForm({
    defaultValues: {},
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [totalCftScore, setTotalCftScore] = useState(0);
  const [totalQualityScore, setTotalQualityScore] = useState(0);
  const [totalScoreAuditor, setTotalAuditoScore] = useState(0)
  const [totalSustainabilityScore, setTotalSustainabilityScore] = useState(0);
  const [showMoreDocuments, setShowMoreDocuments] = useState(false);
  const [selectedScores, setSelectedScores] = useState([]);
  const [remarkEditable, setRemarkEditable] = useState(false);
  const [additionalNCDetails, setAdditionalNCDetails] = useState({});
  const [submitLoading, setSubmitionLoading] = useState(false);
  const [remarkAccept, setRemarkAccept] = useState(false);
  const [remarkApprove, setRemarkApprove] = useState(false);
  const [remark, setRemark] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [remarkNsaApprove, setRemarkNsaApprove] = useState(false)
  const [reasonAudit, setReasonAudit] = useState([]);
  const [rejectNsaApplication, setRejectNsaApplication] = useState(false);
  let history = useHistory();
  const dataEmpId = userDetails();
  const EmpId = dataEmpId?.EmployeeId;
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const vendorRegId = searchParams.get("VendorRequirementRegistrationId");
  const nsaAuditDetailId = searchParams.get("nsaAuditDetailId");
  const [showExceptionPopup, setShowExceptionPopup] = useState(false);
  const [showExceptionPopupSummary, setShowExceptionPopupSummary] = useState(false);
  const [showImageGalleryPopup, setShowImageGalleryPopup] = useState(false);
  const defaultSelectReason = reasonAudit?.find(
    (reason) => reason.ReasonId === 1
  );
  const [showMainPopup, setShowMainPopup] = useState(false); // Different state for main component popup

  const handleShowMainPopup = () => {
    setShowMainPopup(true);
  };

  const handleCloseMainPopup = () => {
    setShowMainPopup(false);
  };
  useEffect(() => {
    popFormSetvalue("AuditScoreValue", {
      value: defaultSelectReason?.ReasonId || "",
      label: defaultSelectReason?.ReasonName || "", // Provide the label property
    });
  }, [defaultSelectReason]);

  useEffect(() => {
    getUsers(vendorRegId, nsaAuditDetailId);
    getAssignAuditorListing();
  }, []);
  const getAssignAuditorListing = () => {
    getReasonAuditListing()
      .then((res) => {
        setReasonAudit(res?.Data);
      })
      .catch(() => { });
  };
  const renderListing = (label) => {
    if (label === "auditScore") {
      return reasonAudit.map((typeofEstablishment) => ({
        value: typeofEstablishment.ReasonId,
        label: typeofEstablishment.ReasonName,
      }));
    }
  };
  const [minDate, setMinDate] = useState(null);
  

  const [minAllowedDate, setMinAllowedDate] = useState(null)
  useEffect(() => {
    if (viewDataFromSupplier && viewDataFromSupplier?.ApprovedDate) {
      const tomorrowDate = new Date();
      tomorrowDate.setDate(tomorrowDate.getDate() + 1);
      setMinAllowedDate(tomorrowDate) // Increment the date by one day      setMinDate(tomorrow);
    }
  }, [viewDataFromSupplier]);

  const handleDateChange = (selectedDate) => {
    const date = new Date(selectedDate);
    // Example: Format to YYYY-MM-DD
    const formattedDate = `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;

    // if (selectedDate == minDate) {
    setMinDate(formattedDate);
    // }
    // Handle other date change actions if needed
  };
  const { viewDetailReport } = useSelector(
    (state) => state?.ViewDetailReportReducer
  );

  // useEffect(() => {
  //   if (viewDetailReport?.data?.auditDetailReportList) {
  //     
  //     const initialScores =
  //       viewDetailReport?.data?.auditDetailReportList?.flatMap((group) =>
  //         group.assessmentQuestionDetails.map((question) => ({
  //           assessmentQuestionId: question.assessmentQuestionId,
  //           selfAssessmentId: question?.selfAssessmentId,
  //           cftScore: question.cftScore || null,
  //           cftRemark: question.cftRemark || null,
  //           ncDetails: question.ncDetailModels.map((nc) => ({
  //             ncRemark: nc.ncRemark,
  //             createdDate: nc.createdDate,
  //             modifiedDate: nc.modifiedDate,
  //             createdBy: nc.createdBy,
  //             modifiedBy: nc.modifiedBy,
  //             nsaAuditAssessmentId: nc.nsaAuditAssessmentId,
  //           })),
  //         }))
  //       );
  //     setSelectedScores(initialScores);
  //     setAuditStatusTab(viewDetailReport?.data?.nsaAuditStatus);
  //   }
  // }, [viewDetailReport]);cftScore checkPointGroupName
  // useEffect(() => {
  //   if (viewDetailReport?.data?.auditDetailReportList) {

  //     let qualityScore = 0;
  //     let esgScore = 0;
  //     let totalCftScore = 0; // Total cftScore across all groups

  //     const initialScores =
  //       viewDetailReport?.data?.auditDetailReportList?.flatMap((group) => {
  //         return (group.assessmentQuestionDetails.map((question) => {

  //           totalCftScore += question.cftScore || 0; // Accumulating cftScore for each question
  //           if (group?.checkPointGroupName == "ESG/Sustainability") {
  //             esgScore = esgScore + question.cftScore;
  //           }
  //           if (group?.checkPointGroupName == "Quality") {
  //             qualityScore = qualityScore + question.cftScore;
  //           }
  //           return (({
  //             checkPointGroupName: group?.checkPointGroupName,
  //             assessmentQuestionId: question.assessmentQuestionId,
  //             selfAssessmentId: question?.selfAssessmentId,
  //             cftScore: question.cftScore || null,
  //             cftRemark: question.cftRemark || null,
  //             ncDetails: question.ncDetailModels.map((nc) => ({
  //               ncRemark: nc.ncRemark,
  //               createdDate: nc.createdDate,
  //               modifiedDate: nc.modifiedDate,
  //               createdBy: nc.createdBy,
  //               modifiedBy: nc.modifiedBy,
  //               nsaAuditAssessmentId: nc.nsaAuditAssessmentId,
  //             })),
  //           }))
  //         }
  //         ))
  //       }
  //       );

  //     // 
  //     setTotalCftScore(totalCftScore)
  //     setTotalQualityScore(qualityScore)
  //     setTotalSustainabilityScore(esgScore)
  //     setSelectedScores(initialScores);
  //     setAuditStatusTab(viewDetailReport?.data?.nsaAuditStatus);
  //   }
  // }, [viewDetailReport]);
  useEffect(() => {
    if (viewDetailReport?.data?.auditDetailReportList) {
      let qualityScore = 0;
      let esgScore = 0;
      let totalCftScore = 0;
      let totalQualityQuestions = 0;
      let totalEsgQuestions = 0;
      let totalQuestionsCount = 0;

      const initialScores = viewDetailReport?.data?.auditDetailReportList?.flatMap((group) => {
        const questionCount = group.assessmentQuestionDetails.length;
        totalQuestionsCount += questionCount;

        return group.assessmentQuestionDetails.map((question) => {
          totalCftScore += question.cftScore || 0;
          if (group?.checkPointGroupName === "ESG/Sustainability") {
            esgScore += question.cftScore || 0;
            totalEsgQuestions += 1;
          }
          if (group?.checkPointGroupName === "Quality") {
            qualityScore += question.cftScore || 0;
            totalQualityQuestions += 1;
          }

          return {
            checkPointGroupName: group?.checkPointGroupName,
            assessmentQuestionId: question.assessmentQuestionId,
            selfAssessmentId: question?.selfAssessmentId,
            cftScore: (question.cftScore || question.cftScore === 0) ? question.cftScore : null,
            cftRemark: question.cftRemark || null,
            ncDetails: question.ncDetailModels.map((nc) => ({
              ncRemark: nc.ncRemark,
              createdDate: nc.createdDate,
              modifiedDate: nc.modifiedDate,
              createdBy: nc.createdBy,
              modifiedBy: nc.modifiedBy,
              nsaAuditAssessmentId: nc.nsaAuditAssessmentId,
            })),
          };
        });
      });

      // Calculate percentage scores
      const totalPossibleCftScore = totalQuestionsCount * 4;
      const qualityPercentage = totalQualityQuestions > 0 ? (qualityScore / (totalQualityQuestions * 4)) * 100 : 0;

      const esgPercentage = totalEsgQuestions > 0 ? (esgScore / (totalEsgQuestions * 4)) * 100 : 0;

      const overallPercentage = totalQuestionsCount > 0 ? (totalCftScore / totalPossibleCftScore) * 100 : 0;
      setTotalAuditoScore(overallPercentage)
      setTotalCftScore(overallPercentage);
      setTotalQualityScore(qualityPercentage);
      setTotalSustainabilityScore(esgPercentage);

      setSelectedScores(initialScores);
      setAuditStatusTab(viewDetailReport?.data?.nsaAuditStatus);
      setViewDataFromReport(viewDetailReport?.data)
      setAuditStatusFlagCheck(viewDetailReport?.data?.approvedDate)
      setDeleteFlagCheck(viewDetailReport?.data?.latitude)
      // Log total number of questions and total scores






    }
  }, [viewDetailReport]);

  const onPopupConfirmSubmit = () => {
    setSubmitionLoading(true);
    setRejectNsaApplication(false);
    if (vendorRegId) {
      const payload = {
        VendorRequirementRegistrationId: vendorRegId
      };
      axiosHelper.post(`${APIUSEROLD.rejectNsaApplication}`, payload)
        .then((response) => {
          
          if (response.data.IsSuccessful) {
            notify.success(response?.data?.FriendlyMessage)
            // hidePageLoader()
            if (viewDataFromSupplier?.IsBlockedVendor) {
              history.push("/supplier-unblocking-request");
            } else {
              history.push("/vendor-need-list");
            }
          }
        })
        .catch((error) => {
          // hidePageLoader();
          if (!error?.response?.data?.IsSuccessful) {
            notify.error(error?.response?.data?.ErrorMessage)
          }
        });
    }
  };

  const popupInputData = (data) => {
    // 
    setRemark(data);
  };
  const closePopUp = () => {
    setRemarkAccept(false);
    setRemarkApprove(false);
    setRemarkNsaApprove(false)
    setShowPopup(false);
  };
  const getUsers = async (vendorRegId, nsaAuditDetailId) => {
    try {
      await dispatch(
        fetchViewDetailReport({
          vendorID: vendorRegId,
          nsaAuditDetailId: nsaAuditDetailId,
        })
      );
    } catch (error) {

    }
  };
  // 
  // const handleCFTScoreChange = (assessmentQuestionId, e) => {
  //   const value = parseInt(e.target.value);
  //   const updatedScores = selectedScores.map((score) => {
  //     if (score.assessmentQuestionId === assessmentQuestionId) {
  //       return {
  //         ...score,
  //         cftScore: value,
  //       };
  //     }
  //     return score;
  //   });
  //   setSelectedScores(updatedScores);
  // };
  const handleCFTScoreChange = (assessmentQuestionId, e) => {
    const value = parseInt(e.target.value);

    // Update the selectedScores array by mapping over it
    const updatedScores = selectedScores.map((score) => {
      // If the assessmentQuestionId matches, update the cftScore
      if (score.assessmentQuestionId === assessmentQuestionId) {
        return {
          ...score,
          cftScore: value,
        };
      }
      // Otherwise, return the score object unchanged
      return score;
    });

    // Update the state with the modified selectedScores array
    setSelectedScores(updatedScores);

    // Recalculate totalCftScore, totalQualityScore, and totalSustainabilityScore
    let newTotalCftScore = 0;
    let newTotalQualityScore = 0;
    let newTotalSustainabilityScore = 0;
    let totalQualityQuestions = 0;
    let totalEsgQuestions = 0;

    updatedScores.forEach((score) => {
      newTotalCftScore += score.cftScore || 0;
      if (score.checkPointGroupName === "Quality") {
        newTotalQualityScore += score.cftScore || 0;
        totalQualityQuestions += 1;
      }
      if (score.checkPointGroupName === "ESG/Sustainability") {
        newTotalSustainabilityScore += score.cftScore || 0;
        totalEsgQuestions += 1;
      }
    });

    const totalQuestionsCount = updatedScores.length;
    const totalPossibleCftScore = totalQuestionsCount * 4;
    const qualityPercentage = totalQualityQuestions > 0 ? (newTotalQualityScore / (totalQualityQuestions * 4)) * 100 : 0;
    const esgPercentage = totalEsgQuestions > 0 ? (newTotalSustainabilityScore / (totalEsgQuestions * 4)) * 100 : 0;
    const overallPercentage = totalQuestionsCount > 0 ? (newTotalCftScore / totalPossibleCftScore) * 100 : 0;

    setTotalCftScore(overallPercentage);
    setTotalQualityScore(qualityPercentage);
    setTotalSustainabilityScore(esgPercentage);

    // Log percentages



  };





  const handleCFTRemarkChange = (assessmentQuestionId, e) => {
    const { value } = e.target;
    const updatedScores = selectedScores.map((score) => {
      if (score.assessmentQuestionId === assessmentQuestionId) {
        return {
          ...score,
          cftRemark: value,
        };
      }
      return score;
    });
    setSelectedScores(updatedScores);
  };

  const handleAddNCDetail = (assessmentQuestionId) => {
    setAdditionalNCDetails((prevNCDetails) => ({
      ...prevNCDetails,
      [assessmentQuestionId]: [
        ...(prevNCDetails[assessmentQuestionId] || []),
        "",
      ],
    }));
  };

  const handleNCRemarkChange = (e, assessmentQuestionId, ncIndex) => {
    const { value } = e.target;
    const updatedScores = [...selectedScores];
    const scoreIndex = updatedScores.findIndex(
      (score) => score.assessmentQuestionId === assessmentQuestionId
    );
    if (scoreIndex !== -1) {
      updatedScores[scoreIndex].ncDetails[ncIndex].ncRemark = value;
      setSelectedScores(updatedScores);
    }
  };

  const handleAdditionalNCRemarkChange = (e, assessmentQuestionId, index) => {
    const { value } = e.target;
    setAdditionalNCDetails((prevNCDetails) => ({
      ...prevNCDetails,
      [assessmentQuestionId]: prevNCDetails[assessmentQuestionId].map(
        (ncDetail, i) => (i === index ? value : ncDetail)
      ),
    }));
  };

  const handleSave = async (action) => {
    try {
      setSubmitionLoading(true);
      const editedData = {
        CFTQuestionUpdates: selectedScores?.map((score) => {
          const ncDetailsFromScores = score?.ncDetails?.map((ncDetail) => ({
            NCRemark: ncDetail.ncRemark,
          })) || [];

          const ncDetailsFromAdditional = (additionalNCDetails[score.assessmentQuestionId] || [])
            .filter((ncDetail) => ncDetail.trim() !== "")
            .map((ncDetail) => ({
              NCRemark: ncDetail,
            }));

          return {
            AssessmentQuestionId: score.assessmentQuestionId,
            SelfAssessmentId: score.selfAssessmentId,
            CFTScore: score.cftScore,
            CFTRemark: score.cftRemark,
            NSAAuditDetailId: nsaAuditDetailId,
            NCDetailList: [...ncDetailsFromScores, ...ncDetailsFromAdditional],
          };
        }),
        Action: action,
        SustainiblityScoreAuditor: totalSustainabilityScore,
        QualityScoreByAuditor: totalQualityScore,
        OverAllScoreByAuditor: totalCftScore,
        AssignCFTEmpId: EmpId?.EmployeeId,
      };

      const res = await new Promise((resolve, reject) => {
        dispatch(UpdateViewDetailReportService(editedData, resolve, reject));
      });

      if (res && res.IsSuccessful) {
        getUsers(parseInt(vendorRegId), parseInt(nsaAuditDetailId));
        getVendorListFormDetailById(vendorRegId);
        Toaster.success(res.FriendlyMessage);
        setRemarkEditable(false);
        setAdditionalNCDetails({});
      } else {
        Toaster.error("An error occurred. Please try again.");
      }
    } catch (error) {
      Toaster.error(error?.response?.data?.ErrorMessage || "An error occurred. Please try again.");
    } finally {
      setSubmitionLoading(false);
    }
  };

  const handleDeleteAdditionalNCDetail = (assessmentQuestionId, ncIndex) => {
    setSelectedScores((prevScores) => {
      return prevScores.map((score) => {
        if (score.assessmentQuestionId === assessmentQuestionId) {
          const updatedNCDetails = score.ncDetails.filter((_, index) => index !== ncIndex);
          return { ...score, ncDetails: updatedNCDetails };
        }
        return score;
      });
    });

    setAdditionalNCDetails((prevNCDetails) => {
      const updatedNCDetails = { ...prevNCDetails };
      if (updatedNCDetails[assessmentQuestionId]) {
        updatedNCDetails[assessmentQuestionId] = updatedNCDetails[assessmentQuestionId].filter((_, index) => index !== ncIndex);

        if (updatedNCDetails[assessmentQuestionId].length === 0) {
          delete updatedNCDetails[assessmentQuestionId];
        }
      }

      return updatedNCDetails;
    });
  };


  const handleNSAAKYSpproveReport = async () => {
    try {
      if (!remark) {
        // setFormErrorForCorrection("Please enter a remark");
        return;
      }
      const userDetail = userDetails();
      const reviewRequesterData = {
        IsKYS2ApprovedByApprover: true,
        KYS2ApproverRemark: remark,
        NSAAuditDetailId: parseInt(nsaAuditDetailId),
        KYS2ApproverEmployeeId: parseInt(userDetail?.EmployeeId),
        VendorRequirementRegistrationId: parseInt(vendorRegId),
      };
      setSubmitionLoading(true);

      const res = await new Promise((resolve, reject) => {
        dispatch(
          nsaApproveKYSReport(reviewRequesterData, (response) => {
            if (response) {
              resolve(response);
            } else {
              reject("An error occurred while processing the request");
            }
          })
        );
      });

      if (res && res?.data?.IsSuccessful) {
        Toaster.success(res?.data?.FriendlyMessage);
        history.push("/nsa-list");
      }

      setRemark("");
      setRemarkAccept(false);
      setRemarkApprove(false);
    } catch (error) {

      // Handle the error, e.g., display an error message to the user
    } finally {
      setSubmitionLoading(false);
    }
  };
  const handleNSAApproveReport = async () => {
    try {
      if (!remark) {
        // setFormErrorForCorrection("Please enter a remark");
        return;
      }
      const userDetail = userDetails();
      const reviewRequesterData = {
        IsApprovedByApprover: true,
        ApproverRemark: remark,
        NSAAuditDetailId: parseInt(nsaAuditDetailId),
        ApproverEmployeeId: parseInt(userDetail?.EmployeeId),
        vendorRequirementRegistrationId: parseInt(vendorRegId),
      };
      setSubmitionLoading(true);

      const res = await new Promise((resolve, reject) => {
        dispatch(
          nsaApproveReport(reviewRequesterData, (response) => {
            if (response) {
              resolve(response);
              Toaster.success(res?.data?.FriendlyMessage);
              history.push("/nsa-list");

            } else {
              reject("An error occurred while processing the request");
            }
          })
        );
      });



      setRemark("");
      setRemarkAccept(false);
      setRemarkApprove(false);
    } catch (error) {

      // Handle the error, e.g., display an error message to the user
    } finally {
      setSubmitionLoading(false);
    }
  };

  const handleRequestReviewReport = async () => {
    try {
      if (!remark) {
        // setFormErrorForCorrection("Please enter a remark");
        return;
      }
      const reviewRequesterData = {
        RequestReviewRemark: remark,
        NSAAuditDetailID: parseInt(nsaAuditDetailId),
        VendorRequirementRegistrationId: parseInt(vendorRegId),
      };
      setSubmitionLoading(true);

      const res = await new Promise((resolve, reject) => {
        dispatch(
          nsaRequestReviewReport(reviewRequesterData, (response) => {
            if (response) {
              resolve(response);
              // Toaster.success(res?.data?.FriendlyMessage);
              // history.push("/nsa-list");

            } else {
              reject("An error occurred while processing the request");
            }
          })
        );
      });
      if (res && res?.data?.IsSuccessful) {
        Toaster.success(res?.data?.FriendlyMessage);
        history.push("/nsa-list");
      }
      setRemark("");
      setRemarkAccept(false);
      setRemarkApprove(false);
    } catch (error) {

      // Handle the error, e.g., display an error message to the user
    } finally {
      setSubmitionLoading(false);
    }
  };

  let iterationCount = 0;
  const handleShowMoreDocuments = (questionId) => {

    setSelectedQuestion(questionId);
    setShowImageGalleryPopup(true);
  };

  const toggleRemarkEditable = () => {
    setRemarkEditable((prevState) => !prevState);
  };
  const closeExceptionPopUp = () => {
    setShowExceptionPopup(false);
    setShowImageGalleryPopup(false);
    setShowExceptionPopupSummary(false);
  };

  // const handleSaveExceptionFlow = async (data) => {
  //   try {
  //     let empId = userDetails();
  //     
  //     const roundedScore = Math.round(totalScoreAuditor); // Rounds to nearest integer
  //     // Now, you can send the payload
  //     const payload = {
  //       VendorRequirementRegistrationId: parseInt(vendorRegId),
  //       NSAAuditDetailID: parseInt(nsaAuditDetailId),
  //       // ResonDetail: data?.AuditScoreValue?.value,
  //       ResonDetail: [
  //         {
  //           ExceptionalFlowReasonID: data?.AuditScoreValue?.value,
  //           ExpectedDateOfCorrection: null
  //         },
  //       ],
  //       RequestInitiatedBy: parseInt(empId?.EmployeeId),
  //       AuditScoreValue: roundedScore <= 61 ? roundedScore : totalQualityScore || totalSustainabilityScore,
  //       RequestSentRemark: data?.RequestSentRemark,
  //       RequestSendDate: null
  //       // Your payload data
  //     };
  //     // 
  //     return;
  //     setSubmitionLoading(true);
  //     const res = await new Promise((resolve, reject) => {
  //       dispatch(
  //         intiateExceptionFlow(payload, (response) => {
  //           if (response) {
  //             resolve(response);
  //             getUsers(parseInt(vendorRegId), parseInt(nsaAuditDetailId));

  //           } else {
  //             reject("An error occurred while processing the request");
  //           }
  //         })
  //       );
  //     });
  //     if (res && res?.IsSuccessful) {
  //       Toaster.success(res?.FriendlyMessage);
  //       history.push("/nsa-list");
  //     }

  //     setRemark("");
  //     setRemarkAccept(false);
  //     setRemarkApprove(false);
  //     setShowExceptionPopup(false);
  //     setShowExceptionPopupSummary(false);

  //     // Now you can send the payload to the desired endpoint
  //     // sendPayloadToEndpoint(payload);
  //   } catch (error) {
  //     setSubmitionLoading(false);

  //     // Handle the error accordingly, you can show an error message or perform other actions
  //   } finally {
  //     setSubmitionLoading(false);
  //   }
  // };
  const handleSaveExceptionFlow = async (data) => {
    try {
      let empId = userDetails();
      // console.log(
      //   Math.round(totalScoreAuditor),
      //   "overAllScore",
      //   totalQualityScore,
      //   "QualityScore",
      //   totalSustainabilityScore,
      //   "totalSgScore"
      // );

      const roundedScore = Math.round(totalScoreAuditor); // Rounds to nearest integer
      const esgScore = Math.round(totalSustainabilityScore); // Rounds to nearest integer
      const QualityScore = Math.round(totalQualityScore); // Rounds to nearest integer

      // Determine the AuditScoreValue based on the conditions
      let AuditScoreValue;
      if (roundedScore <= 60) {
        AuditScoreValue = roundedScore;
      } else if (QualityScore < 60 && esgScore < 60) {
        AuditScoreValue = Math.min(QualityScore, esgScore);
      } else if (QualityScore < 60) {
        AuditScoreValue = QualityScore;
      } else if (esgScore < 60) {
        AuditScoreValue = esgScore;
      } else {
        // Handle the default case if none of the above conditions are met
        AuditScoreValue = roundedScore; // Replace with appropriate default handling logic
      }

      // Prepare the payload
      const payload = {
        VendorRequirementRegistrationId: parseInt(vendorRegId),
        NSAAuditDetailID: parseInt(nsaAuditDetailId),
        ResonDetail: [
          {
            ExceptionalFlowReasonID: data?.AuditScoreValue?.value,
            ExpectedDateOfCorrection: null,
          },
        ],
        RequestInitiatedBy: parseInt(empId?.EmployeeId),
        AuditScoreValue, // Use the determined AuditScoreValue
        RequestSentRemark: data?.RequestSentRemark,
        RequestSendDate: null,
        // Your payload data
      };

      // 
      // return;
      setSubmitionLoading(true);
      const res = await new Promise((resolve, reject) => {
        dispatch(
          intiateExceptionFlow(payload, (response) => {
            if (response) {
              resolve(response);
              getUsers(parseInt(vendorRegId), parseInt(nsaAuditDetailId));
            } else {
              reject("An error occurred while processing the request");
            }
          })
        );
      });

      if (res && res?.IsSuccessful) {
        Toaster.success(res?.FriendlyMessage);
        history.push("/nsa-list");
      }

      setRemark("");
      setRemarkAccept(false);
      setRemarkApprove(false);
      setShowExceptionPopup(false);
      setShowExceptionPopupSummary(false);

    } catch (error) {
      setSubmitionLoading(false);

      // Handle the error accordingly, you can show an error message or perform other actions
    } finally {
      setSubmitionLoading(false);
    }
  };

  const handleSaveReauditFlow = async (data) => {
    try {
      let empId = userDetails();
      // Now, you can send the payload
      const payload = {
        VendorRequirementRegistrationId: parseInt(vendorRegId),
        NSAAuditDetailID: parseInt(nsaAuditDetailId),
        ReAuditRemark: data?.RemarkReaudit,
        ReAuditAfterDate: minDate,
        Version: 1,
        ReAuditBy: parseInt(empId?.EmployeeId),

        // Your payload data
      };

      setSubmitionLoading(true);
      const res = await new Promise((resolve, reject) => {
        dispatch(
          reAuditFlow(payload, (response) => {
            if (response) {
              resolve(response);
              getUsers(parseInt(vendorRegId), parseInt(nsaAuditDetailId));
            } else {
              reject("An error occurred while processing the request");
            }
          })
        );
      });
      if (res && res?.IsSuccessful) {
        Toaster.success(res?.FriendlyMessage);
        history.push("/nsa-list");
      }
      setShowPopup(false);
      setRemark("");
      setRemarkAccept(false);
      setRemarkApprove(false);
      setShowExceptionPopup(false);
      setShowExceptionPopupSummary(false);
      // Now you can send the payload to the desired endpoint
      // sendPayloadToEndpoint(payload);
    } catch (error) {
      setSubmitionLoading(false);

      // Handle the error accordingly, you can show an error message o3r222 perform other actions
    } finally {
      setSubmitionLoading(false);
    }
  };

  const calculateCheck = (param1, param2) => {
    return param1?.toString() === param2?.toString()
  }
  const getDownloadReportService = async (vendorRegId, nsaAuditDetailId) => {
    setSubmitionLoading(true);
    try {
      const res = await getDownloadReport({
        VendorRequirementRegistrationId: vendorRegId,
        NSAAuditDetailId: nsaAuditDetailId,
      });
      const downloadUrl = res; // Assuming the URL is directly returned by the response



      if (downloadUrl) {
        // Create an anchor element and open the link in a new tab
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('target', '_blank'); // Open in a new tab
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {

    } finally {
      setSubmitionLoading(false);
    }
  };
  // const handleDeleteAdditionalNCDetail =(assesmentQuestionId,ncRemarkId) =>{
  //   

  // }
  const originalDate = new Date(viewDetailReport?.data?.reAuditAfterDate);
  const dateOnly = new Date(originalDate.getFullYear(), originalDate.getMonth(), originalDate.getDate());



  if (submitLoading) {
    return (
      <div>
        <LoaderCustom customClass="simulation-Loader" />
      </div>
    );
  }
  return (

    <div className="hl-audit-report-page">

      <Row className={`filter-row-large`}>
        <Col md="3" className="d-flex align-items-center hl-location-details">
          {
            viewDetailReport?.data?.auditReportLocation && (
              <>
                <div className="hl-location-icon mr-3" /><strong>{viewDetailReport?.data?.auditReportLocation}</strong>
              </>
            )
          }
        </Col>
        <Col md="9" className="mb-3 d-flex justify-content-end">
          <div className="d-flex justify-content-end bd-highlight w100 view-details-btn-group">
            <>
              {viewDetailReport?.data?.isExceptionInitiated &&
                !viewDetailReport?.data?.isKYS2ApprovedByApprover &&
                viewDetailReport?.data?.kys2LevelId?.some(
                  (id) => id == EmpId
                ) &&
                viewDetailReport?.data?.nsaAuditStatus == 11 && (
                  <button
                    type="button"
                    className="user-btn mr-2"
                    title="Initiate Exception Flow"
                    onClick={() => setShowExceptionPopup(true)}
                  >
                    <div className="send-for-approval ms-1"></div>Initiate Exception Flow
                  </button>
                )}
              {!viewDetailReport?.data?.isAudit &&
                !viewDetailReport?.data?.isKYS2ApprovedByApprover &&
                viewDetailReport?.data?.kys2LevelId?.some(
                  (id) => id == EmpId
                ) &&
                viewDetailReport?.data?.nsaAuditStatus == 11 && !viewDetailReport?.data?.reAudit && (
                  <button
                    type="button"
                    className="user-btn mr-2"
                    title="Request Re-Audit"
                    onClick={() => setShowPopup(true)}
                  >
                    <div className="save-icon ms-1"></div>Request Re-Audit
                  </button>
                )}
              {
                viewDetailReport?.data?.isRejectButtonVisible &&
                !viewDetailReport?.data?.isKYS2ApprovedByApprover &&
                viewDetailReport?.data?.kys2LevelId?.some(
                  (id) => id == EmpId
                )
                &&
                <button
                  type="button"
                  className="user-btn mr-2"
                  title="Reject Report"
                  onClick={() => setRejectNsaApplication(true)}
                >
                  <div className="save-icon ms-1"></div>Reject Nsa Report
                </button>
              }
              {viewDetailReport?.data?.nsaAuditStatus != 29 && (
                <button
                  type="button"
                  className="user-btn mr-2"
                  title="Download Report"
                  onClick={() => getDownloadReportService(vendorRegId, nsaAuditDetailId)}
                >
                  <div className="save-icon ms-1"></div>Download Report
                </button>
              )}


              {/* {!viewDetailReport?.data?.isExceptionInitiated &&
                !viewDetailReport?.data?.isKYS2ApprovedByApprover &&
                viewDetailReport?.data?.kys2LevelId?.some(
                  (id) => id == EmpId
                ) &&
                viewDetailReport?.data?.nsaAuditStatus == 21 && (
                  <button
                    type="button"
                    className="user-btn mr-2"
                    title="NSA Approved"
                    onClick={() => setRemarkNsaApprove(true)}
                  >
                    <div className="save-icon ms-1"></div>NSA Approved
                  </button>
                )} */}
            </>
            {(viewDetailReport?.data?.auditMethod == 1 ||
              (viewDetailReport?.data?.auditMethod == 2 && viewDetailReport?.data?.latitude != null && viewDetailReport?.data?.longitude != null)) &&
              (viewDetailReport?.data?.assignCftId?.some((id) => id == EmpId)) &&
              (viewDetailReport?.data?.reAuditAfterDate == null ||
                dateOnly <= new Date().setHours(0, 0, 0, 0)) &&
              (viewDetailReport?.data?.nsaAuditStatus == 19 || viewDetailReport?.data?.nsaAuditStatus == 29) && (
                <button
                  type="button"
                  className="user-btn mr-2"
                  title="Edit Report"
                  onClick={toggleRemarkEditable}
                >
                  <div className="edit-icon ms-1"></div>Edit Report
                </button>
              )}
            {(viewDetailReport?.data?.auditMethod == 1 ||
              (viewDetailReport?.data?.auditMethod == 2 && viewDetailReport?.data?.latitude != null && viewDetailReport?.data?.longitude != null)) &&
              (viewDetailReport?.data?.assignCftId?.some((id) => id == EmpId)) &&
              (viewDetailReport?.data?.reAuditAfterDate == null ||
                dateOnly <= new Date().setHours(0, 0, 0, 0)) &&
              (viewDetailReport?.data?.nsaAuditStatus == 19 || viewDetailReport?.data?.nsaAuditStatus == 29) && (
                <button
                  type="button"
                  className="user-btn mr-2"
                  title="Save Report"
                  onClick={() => handleSave("SaveReport")}
                  disabled={!remarkEditable}
                >
                  <div className="save-icon ms-1"></div>Save Report
                </button>
              )}
            {(viewDataFromSupplier?.AssignAuditorID == EmpId) &&
              ((viewDetailReport?.data?.auditMethod == 1 ||
                (viewDetailReport?.data?.auditMethod == 2 && viewDetailReport?.data?.latitude != null && viewDetailReport?.data?.longitude != null)) &&
                (viewDetailReport?.data?.reAuditAfterDate == null ||
                  dateOnly <= new Date().setHours(0, 0, 0, 0)) &&
                (viewDetailReport?.data?.nsaAuditStatus == 19 || viewDetailReport?.data?.nsaAuditStatus == 29)) && (
                <button
                  type="button"
                  className="user-btn mr-2"
                  title="Submit Report"
                  // disabled={!remarkEditable}
                  onClick={() => handleSave("SubmitReport")}
                >
                  <div className="save-icon ms-1"></div>Submit Report
                </button>
              )}
            {EmpId == viewDataFromSupplier?.VNFLastLevelApproverId &&
              viewDataFromSupplier?.ReportSubmitDate != "null" &&
              viewDetailReport?.data?.nsaAuditStatus == 17 && (
                <button
                  type="button"
                  className="user-btn mr-2 text-nowrap"
                  title="NSA Detail Report Approve"
                  onClick={() => {
                    setRemarkApprove(true);
                  }}
                >
                  <div className="save-icon ms-1"></div>NSA Detail Report Approve
                </button>
              )}
            {EmpId == viewDataFromSupplier?.VNFLastLevelApproverId &&
              viewDataFromSupplier?.ReportSubmitDate !== "null" &&
              viewDetailReport?.data?.nsaAuditStatus == 17 && (
                <button
                  type="button"
                  className="user-btn mr-2 text-nowrap"
                  title="Request for Review"
                  onClick={() => {
                    setRemarkAccept(true);
                  }}
                >
                  <div className="save-icon ms-1"></div>Request for Review
                </button>
              )}
          </div>
          {/* {viewDetailReport?.data?.nsaAuditStatus != 29 && */}
            <button
              type="button"
              className="user-btn mr-2 text-nowrap"
              title="Request for Review"
              onClick={() => {
                setShowExceptionPopupSummary(true);;
              }}
            >
              <div className="save-icon ms-1"></div>Audit Report Summary
            </button>
          {/* } */}
        </Col>
      </Row>
      <div className="hl-nsa-review-details table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Checkpoint Group Name</th>
              <th style={{ width: "280px" }}>Assessment Question</th>
              <th>Supplier Assessment</th>
              <th>Requester Review Assessment</th>
              <th>CFT Assessment</th>
              <th>CFT Remark</th>
              <th>Non-conformities</th>
              <th>Images</th>
            </tr>
          </thead>
          <tbody>
            {viewDetailReport?.data?.auditDetailReportList.map(
              (group, parentIndex) =>
                group.assessmentQuestionDetails.map((question, qIndex) => {
                  const selectedScore = selectedScores[iterationCount] || {}; // Check if selectedScores[qIndex] is definedww
                  iterationCount++;

                  return (
                    <tr key={`${parentIndex}-${qIndex}`}>
                      {qIndex === 0 && (
                        <td rowSpan={group.assessmentQuestionDetails.length}>
                          {group.checkPointGroupName}
                        </td>
                      )}
                      <td>{question?.assessmentQuestion}</td>
                      <td>
                        <div className="hl-score-radio hl-rating-color">
                          {[0, 1, 2, 3, 4].map((score, index) => {
                            return (
                              <label className="hl-radio-label" key={`supplierScore-${qIndex}-${score}`} title={question[`option_${score}_Label`] || ''}
                              >
                                <input
                                  type="radio"
                                  name={`supplierScore-${parentIndex}-${qIndex}`}

                                  // title={question[`Option_${score}_Label`]}
                                  value={
                                    selectedScores[
                                    question?.assessmentQuestionId
                                    ] ?? question?.supplierScore
                                  }
                                  checked={
                                    selectedScore?.[
                                    question?.assessmentQuestionId
                                    ] === undefined &&
                                    question?.supplierScore === score
                                  }
                                  disabled={true}
                                />
                                <span>{score}</span>
                              </label>
                            );
                          })}
                        </div>
                      </td>
                      <td>
                        <div className="hl-score-radio hl-rating-color">
                          {[0, 1, 2, 3, 4].map((score, index) => {
                            return (
                              <label className="hl-radio-label" key={`requesterReviewScore-${qIndex}-${score}`} title={question[`option_${score}_Label`] || ''}>
                                <input
                                  type="radio"
                                  name={`requesterReviewScore-${parentIndex}-${qIndex}`}
                                  value={
                                    selectedScores[
                                    question?.assessmentQuestionId
                                    ] ?? question?.requesterReviewScore
                                  }
                                  checked={
                                    selectedScore?.[
                                    question?.assessmentQuestionId
                                    ] === undefined &&
                                    question?.requesterReviewScore === score
                                  }
                                  disabled={true}
                                />
                                <span>{score}</span>
                              </label>
                            );
                          })}
                        </div>
                      </td>
                      {/* <td>
                        <div className="hl-score-radio hl-rating-color">
                          {[0, 1, 2, 3, 4].map((score, index) => {
                            return (
                              <label key={`cftScore-${qIndex}-${score}`} className="hl-radio-label">
                                <input
                                  type="radio"
                                  name={`cftScore-${question.assessmentQuestionId}`}
                                  value={score} // Set the value of the radio button
                                  // checked={selectedScore?.cftScore === score}
                                  checked={selectedScores[question.assessmentQuestionId]?.cftScore === score || (selectedScores[question.assessmentQuestionId]?.cftScore ===  score === 2)} // Default to 2 if not already set

                                  onChange={(e) =>
                                    handleCFTScoreChange(
                                      question.assessmentQuestionId,
                                      e
                                    )
                                  }
                                  disabled={!remarkEditable} // Disabled when remarkEditable is false
                                />
                                <span>{score}</span>
                              </label>
                            );
                          })}
                        </div>
                      </td> */}
                      <td>
                        <div className="hl-score-radio hl-rating-color">
                          {[0, 1, 2, 3, 4].map((score, index) => {
                            return (
                              <label className="hl-radio-label" key={`cftScore-${qIndex}-${score}`} title={question[`option_${score}_Label`] || ''}>
                                <input
                                  type="radio"
                                  name={`cftScore-${question.assessmentQuestionId}`}
                                  value={score} // Set the value of the radio button
                                  //  checked={selectedScores[question.assessmentQuestionId]?.cftScore === score} // Default to 2 if not already set
                                  // checked={selectedScore?.cftScore === score}
                                  checked={calculateCheck(selectedScore?.cftScore, score)}
                                  onChange={(e) =>
                                    handleCFTScoreChange(
                                      question.assessmentQuestionId,
                                      e
                                    )
                                  }
                                  disabled={!remarkEditable} // Disabled when remarkEditable is false
                                />
                                <span>{score}</span>
                              </label>
                            );
                          })}
                        </div>
                      </td>
                      <td>
                        <textarea
                          value={
                            selectedScores.find(
                              (score) =>
                                score.assessmentQuestionId ===
                                question.assessmentQuestionId
                            )?.cftRemark || ""
                          }
                          onChange={(e) =>
                            handleCFTRemarkChange(
                              question.assessmentQuestionId,
                              e
                            )
                          }
                          name={`cftRemark-${question.assessmentQuestionId}`}
                          maxLength={1000}
                          disabled={!remarkEditable}
                          className="hl-remark-textarea w-100 form-control"
                        />
                      </td>

                      <td>
                        {remarkEditable && (
                          <Button
                            title="Add NC"
                            className="mb-2"
                            onClick={() => handleAddNCDetail(question.assessmentQuestionId)}
                          >
                            <div className="plus mr-0"></div>
                          </Button>
                        )}
                        <div className="hl-textarea-wrap pl-0">

                          {question?.ncDetailModels.map((nc, ncIndex) => {
                            let value = selectedScores.find(
                              (score) => score.assessmentQuestionId === question.assessmentQuestionId
                            )?.ncDetails[ncIndex]?.ncRemark;
                            if (
                              value
                            ) {
                              return (
                                <div key={ncIndex} className="mb-2 d-flex align-items-center">
                                  <textarea
                                    value={
                                      selectedScores.find(
                                        (score) => score.assessmentQuestionId === question.assessmentQuestionId
                                      )?.ncDetails[ncIndex]?.ncRemark || ""
                                    }
                                    onChange={(e) => handleNCRemarkChange(e, question.assessmentQuestionId, ncIndex)}
                                    maxLength={1000}
                                    name={`ncRemark-${question?.assessmentQuestionId}`}
                                    disabled={!remarkEditable}
                                    className="hl-remark-textarea w-100 form-control"
                                  />
                                  {remarkEditable && (
                                    <button
                                      title="Delete"
                                      className="ml-2 Delete hl-delete-icon hl-delete-report-icon"
                                      onClick={() => handleDeleteAdditionalNCDetail(question.assessmentQuestionId, ncIndex)}
                                      type="button"
                                    >
                                      <div className="minus mr-0"></div>
                                    </button>
                                  )}
                                </div>
                              )
                            }
                          }
                          )}
                          {additionalNCDetails[question.assessmentQuestionId]?.map((ncDetail, index) => (
                            <div key={index} className="mb-2">
                              <textarea
                                value={ncDetail}
                                onChange={(e) => handleAdditionalNCRemarkChange(e, question.assessmentQuestionId, index)}
                                className="hl-remark-textarea w-100 form-control"
                              />
                            </div>
                          ))}
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center hl-more-gallery">
                          <div className="hl-more-img-wrap">
                            {question.documents
                              .slice(
                                0,
                                showMoreDocuments[question.assessmentQuestionId]
                                  ? question.documents.length
                                  : 1
                              )
                              .map((document) => (
                                <div
                                  key={document.attachmentId}
                                  className="hl-img-box mb-1"
                                  onClick={() =>
                                    handleShowMoreDocuments(question.documents)
                                  }
                                // onClick={() =>
                                //   handleShowMoreDocuments(document.filePath)
                                // } // Pass document path
                                >
                                  <img
                                    src={document?.filePath}
                                    alt={document?.attachmentName}
                                    className="hl-img-more"
                                  />
                                </div>
                              ))}
                            {question.documents.length === 1 && (
                              <strong
                                onClick={() =>
                                  handleShowMoreDocuments(question.documents)
                                }
                                className="text-link pl-1"
                              >
                                View
                              </strong>
                            )}

                            {question.documents.length > 1 && (
                              <strong
                                onClick={() =>
                                  handleShowMoreDocuments(question.documents)
                                }
                                className="text-link pl-1"
                              >
                                {showMoreDocuments[
                                  question.assessmentQuestionId
                                ]
                                  ? "- Less"
                                  : "+ More"}
                              </strong>
                            )}

                            {question.documents.length === 0 && <span> </span>}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })
            )}
          </tbody>
        </table>
      </div>
      {showExceptionPopupSummary && (
        <PopupMsgWrapper
          size="xl"
          isOpen={showExceptionPopupSummary}
          firstButtonName="Send"
          closePopUp={closeExceptionPopUp}
          header="Audit Report Summary"
          customClass="hl-invite-supplier hl-exception-summary-popup hl-modal-footer-none"
          message={
            <>
              <ExceptionFlowSummary vendorRegId={vendorRegId} nsaAuditDetailId={nsaAuditDetailId} viewDetailReport={viewDetailReport} />
            </>
          }
        />
      )}



      {rejectNsaApplication && (
        <PopupMsgWrapper
          firstButtonName="Proceed"
          secondButtonName="Cancel"
          header=""
          isOpen={rejectNsaApplication}
          closePopUp={() => setRejectNsaApplication(false)}
          confirmPopup={onPopupConfirmSubmit}
          message={
            <>
              Are you sure you want to reject this NSA application? This action cannot be undone.
              If you proceed, the applicant will be notified of the decision.
              We appreciate your careful consideration of this matter
            </>
          }
          iconClass="d-none"
          imgClass="hl-img-confirmation"
          popupWrapper="popup-wrapper-main"

        />)}
      {remarkAccept && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkAccept}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleRequestReviewReport()}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
      {remarkAccept && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkAccept}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleRequestReviewReport()}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
      {remarkApprove && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkApprove}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleNSAApproveReport()}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
      {remarkNsaApprove && (
        <PopupMsgWrapper
          setInputData={popupInputData}
          isOpen={remarkNsaApprove}
          header={"Remark"}
          closePopUp={closePopUp}
          confirmPopup={() => handleNSAAKYSpproveReport()}
          isInputField={true} // Assuming you want an input field in your popup
        />
      )}
      {showExceptionPopup && (
        <PopupMsgWrapper
          isOpen={showExceptionPopup}
          firstButtonName="Send"
          closePopUp={closeExceptionPopUp}
          header="Exception Flow Request"
          confirmPopup={() => {
            // handleSaveExceptionFlow();
            const data = popFormGetValues();
            if (data?.RequestSentRemark && !popFormErrors?.RequestSentRemark) {
              handleSaveExceptionFlow(data);
              // api call
            } else if (!data?.RequestSentRemark) {
              popFormSetError("RequestSentRemark", {
                type: "manual",
                message: "This field is required",
              });
            }
            // popUpFormRef?.current?.submit()
            // Trigger onChange for the "Remarks" field
          }}
          customClass="hl-invite-supplier"
          message={
            <>
              <Col md="12">
                <form className="hl-re-audit-pop-up" ref={popUpFormRef}>
                  <Row className="text-start mb-2">
                    <Col lg="12">
                      <SearchableSelectHookForm
                        name={"AuditScoreValue"}
                        label={"Reason"}
                        placeholder={"Select"}
                        Controller={Controller}
                        control={popFormControl}
                        rules={{ required: true }}
                        register={popFormRegister}
                        options={renderListing("auditScore")}
                        handleChange={() => { }}
                        errors={popFormErrors.AuditScoreValue}
                        disabled={true}
                      />
                    </Col>
                    {/* <Col lg="12">
                      <label>Score - <strong>{Math.round(totalCftScore)}%</strong></label>
                    </Col> */}
                    <Col lg="12">
                      <label>
                        Score - <strong>
                          {Math.round(totalCftScore) < 60
                            ? Math.round(totalCftScore)
                            : totalQualityScore < 60 && totalSustainabilityScore < 60
                              ? Math.round(Math.min(totalQualityScore, totalSustainabilityScore))
                              : totalQualityScore < 60
                                ? Math.round(totalQualityScore)
                                : totalSustainabilityScore < 60
                                  ? Math.round(totalSustainabilityScore)
                                  : "N/A"}%
                        </strong>
                      </label>
                    </Col>
                  </Row>
                  <TextAreaHookForm
                    label={`Remarks`}
                    name={"RequestSentRemark"}
                    Controller={Controller}
                    control={popFormControl}
                    register={popFormRegister}
                    placeholder={"Enter"}
                    rules={{
                      required: "Remarks are required.",
                      maxLength: {
                        value: 250, // Adjusted to allow 250 characters
                        message: "Remarks cannot exceed 250 characters.",
                      },
                    }}
                    handleChange={() => { }}
                    errors={popFormErrors.RequestSentRemark}
                    customClassName={"withBorder"}
                    mandatory={true}
                  />
                </form>
              </Col>
            </>
          }
        />
      )}
      {showImageGalleryPopup && selectedQuestion && (
        <PopupMsgWrapper
          size="lg"
          isOpen={showImageGalleryPopup}
          firstButtonName="Send"
          closePopUp={closeExceptionPopUp}
          header="More Images"
          customClass="hl-invite-supplier hl-img-gallery-popup"
          message={
            <>
              <ImageGallery images={[selectedQuestion]} />
            </>
          }
        />
      )}
      {showPopup && (
        <PopupMsgWrapper
          isOpen={showPopup}
          firstButtonName="Send"
          closePopUp={closePopUp}
          header="Re-Audit Request"
          customClass="hl-invite-supplier"
          confirmPopup={() => {
            // handleSaveExceptionFlow();
            const reaudit = popUpReauditGetValues();
            if (
              reaudit?.RemarkReaudit &&
              !popUpReauditErrors?.RemarkReaudit &&
              !popUpReauditErrors?.ReAuditDate
            ) {
              handleSaveReauditFlow(reaudit);
              // api call
            } else if (!reaudit?.RemarkReaudit) {
              popUpReauditSetError("RemarkReaudit", {
                type: "manual",
                message: "This field is required",
              });
              popUpReauditSetError("ReAuditDate", {
                type: "manual",
                message: "This field is required",
              });
            }
            // popUpFormRef?.current?.submit()
            // Trigger onChange for the "Remarks" field
          }}
          message={
            <>
              <Col md="12" className="hl-error-cmtitle">
                <form className="hl-re-audit-pop-up">
                  <div className="inputbox date-section">
                    <DatePickerHookForm
                      name={`ReAuditDate`}
                      label={"Re-audit After"}
                      handleChange={handleDateChange}
                      rules={{ required: true }}
                      Controller={Controller}
                      register={popUpReauditRegister}
                      control={popUpReauditControl}
                      showMonthDropdown
                      showYearDropdown
                      dateFormat="DD/MM/YYYY"
                      dropdownMode="select"
                      placeholder="Select date"
                      customClassName="withBorder"
                      className="withBorder"
                      autoComplete={"off"}
                      errors={popUpReauditErrors?.ReAuditDate}
                      disabledKeyboardNavigation
                      onChangeRaw={(e) => e.preventDefault()}
                      mandatory={true}
                      minDate={minAllowedDate} // Set the minDate prop
                    />
                  </div>
                  <TextAreaHookForm
                    label={`Remarks`}
                    name={"RemarkReaudit"}
                    Controller={Controller}
                    register={popUpReauditRegister}
                    control={popUpReauditControl}
                    placeholder={"Enter"}
                    rules={{
                      required: "Remarks are required.",
                      maxLength: {
                        value: 250, // Adjusted to allow 250 characters
                        message: "Remarks cannot exceed 250 characters.",
                      },
                    }}
                    handleChange={() => { }}
                    customClassName={"withBorder"}
                    mandatory={true}
                    errors={popUpReauditErrors.RemarkReaudit}
                  // disabled={supplierId ? true : false}
                  />
                </form>
              </Col>
            </>
          }
        />
      )}

    </div>
  );
};
export default ViewDetailedReport;
